import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import classNames from 'classnames';

const { Icon, ActionButton, Stack, Heading, Paragraph } = designSystem;

function Banner({
  interactive = false,
  icon = null,
  onClick,
  captions,
  className = '',
  appearance = 'cta',
}) {
  const { title, description, actionLabel } = captions;
  const actionButtonClassName = classNames(
    'menu-banner__action-button',
    `menu-banner__action-button--${appearance}`
  );
  const containerProps = {
    className: classNames('menu-banner', className, {
      'menu-banner--interactive': interactive,
    }),
  };

  if (interactive) {
    containerProps.onClick = onClick;
  }

  const iconProps = {};

  if (icon?.size) {
    iconProps.size = icon.size;
  }

  if (icon?.strokeWidth) {
    iconProps.strokeWidth = icon.strokeWidth;
  }

  return (
    <div {...containerProps}>
      {icon && <Icon glyph={icon.name} {...iconProps} type={appearance} />}
      <Stack gap="spacing-3-xs">
        <Heading type="heading-6">{title}</Heading>
        <Paragraph>{description}</Paragraph>
        <div className={actionButtonClassName}>
          <ActionButton
            format="text"
            label={actionLabel}
            appearance={appearance}
            {...(!interactive && { onClick })}
          />
        </div>
      </Stack>
    </div>
  );
}

const iconShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
});

Banner.propTypes = {
  className: PropTypes.string,
  interactive: PropTypes.bool,
  icon: iconShape,
  appearance: PropTypes.string,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    actionLabel: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Banner;
